module.exports = __webpack_public_path__ + "14167f77f128b0f57a6263843017fc0f.svg";